import { defineMessages } from 'react-intl';

const messages = defineMessages({
  title: {
    id: 'backbutton.title',
    defaultMessage: 'Back',
  },
});

export default messages;
